import IconFacebook from '@/components/icons/IconFacebook.vue';
import IconInstagram from '@/components/icons/IconInstagram.vue';
import { mapGetters } from 'vuex';
import IconFacebookFill from '@/components/icons/IconFacebookFill.vue';
import HeaderPhones from '@/components/@general/Header/HeaderPhones/index.vue';
import HeaderSocial from '@/components/@general/Header/HeaderSocial/index.vue';
import HeaderLang from '@/components/@general/Header/HeaderLang/index.vue';

export default {
  name: 'HeaderTop',
  components: { HeaderLang, HeaderSocial, HeaderPhones, IconFacebookFill, IconInstagram, IconFacebook },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  watch: {},
  created() {},
  mounted() {},
  computed: {
    ...mapGetters({
      contacts: 'setting/variables'
    })
  },
  methods: {}
};
